import { isEmpty } from "lodash";
import { Logger } from "@lululemon/mwa-logger";

const log = new Logger({ owner: "size-and-fit", app: "bra-quiz-app" });

export const braQuizLogger = ({
  error,
  componentName,
  functionName,
  scopeContexts = {},
  tags = {},
}) => {
  log.error(
    error,
    {
      tags: {
        componentName,
        featureName: "BraQuiz",
        functionName,
        ...tags,
      },
    },
    (scope) => {
      scope.setContext("Original Error Object", error);
      for (const contextName in scopeContexts) {
        // eslint-disable-next-line security/detect-object-injection
        const context = scopeContexts[contextName] || {};
        if (!isEmpty(context)) {
          scope.setContext(contextName, context);
        }
      }
    }
  );
};
